<template>
  <div class="p-0">
    <e-c-tree-select
      v-if="treeSelect"
      :header="header"
      :fieldId="fieldId"
      :items="items"
      :toolTipTitle="toolTipTitle"
      :facetIsSelected="facetIsSelected"
      :facetClicked="facetClicked"
    />
    <e-c-multi-select-facet
      v-else-if="multiSelect"
      :header="header"
      :fieldId="fieldId"
      :items="items"
      :toolTipTitle="toolTipTitle"
      :facetIsSelected="facetIsSelected"
      :facetClicked="facetClicked"
    />
    <e-c-single-select-facet
      v-else
      :header="header"
      :fieldId="fieldId"
      :items="items"
      :toolTipTitle="toolTipTitle"
      :facetIsSelected="facetIsSelected"
      :facetClicked="facetClicked"
    />
  </div>
</template>

<script>
import ECSingleSelectFacet from "@/components/ECSingleSelectFacet";
import ECMultiSelectFacet from "@/components/ec-multiselect/ECMultiSelectFacet";
import ECTreeSelect from "@/components/ECTreeSelect";
export default {
  name: "ECSelectFacet",
  components: { ECTreeSelect, ECMultiSelectFacet, ECSingleSelectFacet },
  props: {
    header: {
      type: String,
      default: '',
    },
    fieldId: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    toolTipTitle: {
      type: String,
      default: '',
    },
    facetIsSelected: Function,
    facetClicked: Function,
    multiSelect: Boolean,
    treeSelect: {
      type: Boolean,
      default: false,
    },
  }
}
</script>
